import {ChangeDetectionStrategy, Component, Optional} from '@angular/core';
import {NbWindowRef} from '@nebular/theme';
import {BaseComponent, DeliveryAddress} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map, takeUntil, tap} from 'rxjs/operators';

@Component({
    selector: 'app-popup-address',
    templateUrl: './popup-address.component.html',
    styleUrls: ['./popup-address.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PopupAddressComponent extends BaseComponent {

  submitted = false;
  refresh = true;

  private address = '';

  constructor(@Optional() protected readonly windowRef: NbWindowRef) {
    super();
  }

  onSelect($event: any) {
    this.address = ($event !== null && 'unrestricted_value' in $event) ? $event.unrestricted_value : '';
    this.cdr.detectChanges();
  }

  onSubmit() {
    if (this.selected()) {
      this.submitted = true;
      this.sendAddress().pipe(
        tap(data => this.handleResponse(data)),
        takeUntil(this.unsubscribe)
      ).subscribe();
    }
  }

  private handleResponse(data) {
    this.submitted = false;
    this.windowRef.close(data);
    if (this.refresh) {
      window.location.href = this.router.url;
    }
  }

  private sendAddress(): Observable<DeliveryAddress> {
    return this.compoApiService.post<DeliveryAddress, DeliveryAddress>('/delivery-address', {header: this.address}).pipe(map(response => response.data));
  }

  selected() {
    return this.address !== null && this.address.length;
  }
}
